import { Grid } from '@material-ui/core';
import { FormikActions, getIn } from 'formik';
import * as _ from 'lodash';
import { inject } from 'mobx-react';
import * as React from 'react';
import ESDialog from 'src/common/ESDialog';
import FullWidthField from 'src/common/FullWidthField';
import SelectField from 'src/common/SelectField/SelectField';
import { IBranch, IRegion } from 'src/Definitions';
import { RegionDto } from 'src/generated_client';
import { IStores } from 'src/Stores';
import * as Yup from 'yup';

interface IBranchFormValues {
    name: string;
    regionId: string;
    distributorCode: string;
    distributor: string;
    generalManager: string;
}

const BranchSchema = Yup.object().shape({
    branch: Yup.object().shape({}),
    distributorCode: Yup.string().required('Distributor Code is Required'),
    name: Yup.string().required('Name is Required'),
    regionId: Yup.string().required('Region is Required'),
});

interface IBranchDialogProps {
    branch?: IBranch;
    close?: () => void;
    isLoading?: boolean;
    isOpen?: boolean;
    getRegions?: (pageNumber?: number, pageSize?: number) => void;
    saveBranch?: (branch: IBranch) => Promise<void>;
    regions?: IRegion[];
}

class BranchDialog extends React.Component<IBranchDialogProps> {
    public save = (values: IBranchFormValues, formikBag: FormikActions<IBranchFormValues>) => {
        this.props.branch!.name = values.name;
        this.props.branch!.distributorCode = values.distributorCode;
        this.props.branch!.distributor = values.distributor;
        this.props.branch!.generalManager = values.generalManager;
        const region = _.find(this.props.regions, { id: values.regionId });
        if (region) {
            this.props.branch!.region = new RegionDto();
            this.props.branch!.region.id = values.regionId;
            this.props.branch!.region.name = region.name;
        } else {
            this.props.branch!.region = new RegionDto();
        }
        this.props.saveBranch!(this.props.branch!).finally(() => formikBag.setSubmitting(false));
    };

    public componentDidMount() {
        this.props.getRegions!(undefined, 5000);
    }

    public getRegionName(region: IRegion) {
        return region.name;
    }

    public getRegionValue(region: IRegion) {
        return region.id;
    }

    public getRegionId() {
        if (this.props.branch && this.props.branch.region) {
            return this.props.branch.region.id || '';
        } else {
            return '';
        }
    }

    public render() {
        const { close, isLoading, isOpen, branch, regions } = this.props;
        const initialValues = {
            distributor: branch!.distributor,
            distributorCode: branch!.distributorCode,
            generalManager: branch!.generalManager,
            name: branch!.name,
            regionId: this.getRegionId(),
        };

        const hasValue = (field: string, values: IBranchFormValues) => {
            const value = getIn(values, field);

            return !!value;
        };

        return (
            <ESDialog
                close={close!}
                initialValues={initialValues}
                isLoading={isLoading}
                open={isOpen!}
                save={this.save}
                title={branch!.isNew ? 'Create Branch' : 'Edit Branch'}
                validationSchema={BranchSchema}
            >
                {({ errors, values }) => (
                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                            <FullWidthField autoFocus name="name" label="Name" required />
                        </Grid>
                        <Grid item xs={12}>
                            <FullWidthField
                                name="distributorCode"
                                label="Distributor Code"
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FullWidthField name="generalManager" label="General Manager" />
                        </Grid>
                        <Grid item xs={12}>
                            <FullWidthField name="distributor" label="Distributor" />
                        </Grid>
                        <Grid item xs={12}>
                            <SelectField
                                data-cy="regionId"
                                getName={this.getRegionName}
                                getValue={this.getRegionValue}
                                inputId="regionId"
                                items={regions}
                                label="Region"
                                name="regionId"
                                fullWidth
                                required
                                errorMessage={errors.regionId}
                                shrinkLabel={hasValue('regionId', values)}
                            />
                        </Grid>
                    </Grid>
                )}
            </ESDialog>
        );
    }
}

const InjectedBranchDialog = inject<IStores, IBranchDialogProps, Partial<IBranchDialogProps>, any>(
    (stores: IStores) => ({
        branch: stores.branches.selectedBranch,
        close: stores.branches.closeDialog,
        getRegions: stores.regions.getAllRegions,
        isLoading: stores.branches.isLoading,
        isOpen: stores.branches.isModalOpen,
        regions: stores.regions.regions,
        saveBranch: stores.branches.saveBranch,
    })
)(BranchDialog);

export default InjectedBranchDialog;



// WEBPACK FOOTER //
// ./src/branches/BranchDialog.tsx